import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { faPaw } from "@fortawesome/pro-solid-svg-icons";

import CardPill from "@/components/shared/CardPill";

import type { ProgramsProps } from "./programs.types";

import s from "./programs.module.scss";

const Programs = ({ isSignedIn }: ProgramsProps) => {
  const pathname = usePathname();

  return (
    <div className={s.wrapper}>
      <Link
        href={
          isSignedIn
            ? "/minha-conta/espaco-pet"
            : `/login?ReturnUrl=${pathname}`
        }
        target={isSignedIn ? "_blank" : "_self"}
      >
        <CardPill
          title="Crie o perfil do seu Pet"
          message="e explore o mundo Cobasi"
          size="lg"
          icon={faPaw}
          iconProps={{ color: "var(--token-colors-neutral-cloud-white)" }}
          variant="lemon"
          showActionButton
        />
      </Link>
    </div>
  );
};

export default Programs;
